export const inset = {
  nano: "4px",
  xs: "8px",
  sm: "16px",
  md: "24px",
  lg: "32px",
};

export const squish = {
  nano: "4px 8px",
  xs: "8px 16px",
  sm: "16px 24px",
  md: "24px 32px",
};

export const spacing = {
  quark: "4px",
  nano: "8px",
  xxxs: "16px",
  xxs: "24px",
  xs: "32px",
  sm: "40px",
  md: "48px",
  lg: "56px",
  xl: "64px",
  xxl: "80px",
  xxxl: "120px",
  huge: "160px",
  giant: "200px",
};

export type SpacingKeys = keyof typeof spacing;
export type Spacing = typeof spacing;

export type SquishKeys = keyof typeof squish;
export type Squish = typeof squish;

export type InsetKeys = keyof typeof inset;
export type Inset = typeof inset;
